export const CategoryConstants = {
    FETCH_CATEGORY_REQUEST: 'FETCH_CATEGORY_REQUEST',
    FETCH_CATEGORY_SUCCESS: 'FETCH_CATEGORY_SUCCESS',
    FETCH_CATEGORY_FAILURE: 'FETCH_CATEGORY_FAILURE'
}